var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pw-input-parent"},[_c('input',_vm._g({directives:[{name:"model",rawName:"v-model",value:(_vm.amount),expression:"amount"}],ref:"numeric",staticClass:"pw-input",attrs:{"placeholder":_vm.placeholder,"type":"text","name":_vm.name,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.amount)},on:{"input":function($event){if($event.target.composing)return;_vm.amount=$event.target.value}}},{
      ..._vm.$listeners,
      blur: _vm.onBlurHandler,
      input: _vm.onInputHandler,
      focus: _vm.onFocusHandler,
    }))])
}
var staticRenderFns = []

export { render, staticRenderFns }